<template>
  <div>
    <div class="app-title">
      <em-view-title :crudState="$_emCommonEditMixin_pathType"></em-view-title>
    </div>
    <section v-menu-permission="'edit'" class="app-content">
      <div class="card">
        <div class="card-body">
          <em-entity-edit-form ref="emEntityEditForm" :entity="modelName"></em-entity-edit-form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// Author Lin
// Date 2021-08-16 17:52:43

import emCommonEditMixin from "@/mixin/em/common/edit";

export default {
  name: "sithMesInventoryTransportApplicationEditView",
  mixins: [emCommonEditMixin],
  computed: {
    modelName() {
      return this.$_emRouterHelperMixin_entityName
    }
  }
};
</script>

<style scoped>
::v-deep .card-body .row div:nth-child(12) .control-label {
  width: 200px;
}
</style>